import "./WealthArchitecture.module.css";
import ExecutiveNavigation from "@/reusable_sections/Header";
import OurSpecializedExpertise from "./sections/OurSpecializedExpertise";
import StrategicServiceGrid from "./sections/StrategicServiceGrid";
import ThePlanningProcess from "./sections/ThePlanningProcess";
import LegacyFooter from "@/reusable_sections/Footer";
export default function WealthArchitecturePage() {
  return <div>
      <ExecutiveNavigation />
      <OurSpecializedExpertise />
      <StrategicServiceGrid />
      <ThePlanningProcess />
      <LegacyFooter />
    </div>;
}